import React, { useEffect } from 'react';
import L from 'leaflet';
import { FullScreen } from 'leaflet.fullscreen';
import 'leaflet.fullscreen/dist/Control.FullScreen.css';

interface Props {
    map: L.Map | null;
    fullscreenElement?: HTMLElement | null;
}

function LeafletFullscreenControl({ map, fullscreenElement }: Props) {
    useEffect(() => {
        if (!map)
            return;

        const control = new FullScreen({
            position: 'topright',
            forceSeparateButton: true,
            fullscreenElement: fullscreenElement || false
        });

        map.addControl(control);

        const invalidateMapSize = () => {
            window.setTimeout(() => map.invalidateSize(), 0);
        };

        map.on('enterFullscreen', invalidateMapSize);
        map.on('exitFullscreen', invalidateMapSize);

        return () => {
            map.off('enterFullscreen', invalidateMapSize);
            map.off('exitFullscreen', invalidateMapSize);
            map.removeControl(control);
        };
    }, [map, fullscreenElement]);

    return null;
}

export default React.memo(LeafletFullscreenControl);
